/** Boverket klimatdeklaration residential program subtype. */
export enum ResidentialProgramType {
  SingleFamily = 'single_family',
  Multifamily = 'multifamily',
  SpecialPurpose = 'special_purpose',
}

/** Boverket klimatdeklaration school program subtype. */
export enum SchoolProgramType {
  Preschool = 'preschool',
  PrimarySchool = 'primary_school',
  HighSchool = 'high_school',
}

/** How each residential subtype reads in the UI. */
export const RESIDENTIAL_PROGRAM_TYPE_LABELS: Record<
  ResidentialProgramType,
  string
> = {
  [ResidentialProgramType.SingleFamily]: 'Single-family',
  [ResidentialProgramType.Multifamily]: 'Multifamily',
  [ResidentialProgramType.SpecialPurpose]: 'Special-purpose',
};

/** How each school subtype reads in the UI. */
export const SCHOOL_PROGRAM_TYPE_LABELS: Record<SchoolProgramType, string> = {
  [SchoolProgramType.Preschool]: 'Preschool',
  [SchoolProgramType.PrimarySchool]: 'Primary school',
  [SchoolProgramType.HighSchool]: 'High school',
};

export const residentialProgramTypes = Object.values(
  ResidentialProgramType,
) as ResidentialProgramType[];

export const schoolProgramTypes = Object.values(
  SchoolProgramType,
) as SchoolProgramType[];

export const isResidentialProgramType = (
  value: unknown,
): value is ResidentialProgramType =>
  residentialProgramTypes.includes(value as ResidentialProgramType);

export const isSchoolProgramType = (
  value: unknown,
): value is SchoolProgramType =>
  schoolProgramTypes.includes(value as SchoolProgramType);
